import { PlusIcon } from "@heroicons/react/24/outline";
import IconButton from "../../../../components/icon-button";
import Input from "../../../../components/input";
import { CharityIssueCategory } from "../../../../models";
import Container from "../../../../components/container";
import { addCharityIssue, State } from "../actions/charity-issue";
import { useActionState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

export default function CharityIssueCreateForm({
  category,
}: {
  category: CharityIssueCategory;
}) {
  const navigate = useNavigate();    
  const initialState: State = {
    message: null,
    success: false,
    errors: {},
    defaultValues: {
      name: "",
    },
  };

  const [state, formAction, isPending] = useActionState(
    addCharityIssue,
    initialState
  );
  useEffect(() => {
    if (state.success) {
      navigate(`/admin/charity-issue-categories/edit/${category.id}?reload=${Date.now()}`);
      toast.success("Charity issue added successfully");
    }
  }, [state]);

  return (
    <form action={formAction} className="flex gap-2 w-full ">
      <Input
        className="w-full"
        name="name"
        id="name"
        placeholder="Name"
        required={true}
      ></Input>
      <input
        type="hidden"
        id="charityIssueCategoryId"
        name="charityIssueCategoryId"
        value={category.id}
      ></input>
      <IconButton label="Add Charity Issue" icon={PlusIcon} loading={isPending}></IconButton>
    </form>
  );
}
